import Tone from 'tone';

// trigger effect automations 10 milliseconds before they are supposed to happen
const LATENCY = 10;

class ParameterFuture {
    constructor(effectNumber, parameter, value, automationContext={}) {
        this.effectNumber = effectNumber;
        this.parameter = parameter;
        this.value = value;
        this.automationContext = automationContext;
    }

    setAtTime(time, duration) {
        this.parameter.set(this.value, undefined, undefined, time);
    }

    getJson() {
        return {
            ... this.automationContext,
            effectNumber: this.effectNumber,
            parameterName: this.parameter.name,
            value: this.value
        };
    }

    getCopy() {
        return new ParameterFuture(
            this.effectNumber, this.parameter, this.value, this.automationContext);
    }
}

export default ParameterFuture;
